import Container from "../../../components/container";
import line from "../../../assets/images/line_technology.svg";

export default function Section5() {

   return (
      <section className="mt-[60px] md:mt-[68px] lg:my-[75px]"
      >
         <Container className="!px-[30px] lg:px-[40px] 2xl:!px-0">
            <div className="flex flex-col items-center">
               <img src={line} alt="line" className="w-full" style={{ objectFit: 'contain' }} />
               <div className="flex flex-col max-w-[1030px] mt-[21px] mb-[24px]">
                  <h3 className="font-bold text-[32px] leading-[60px] text-center text-[#003A75]">Technology we work with</h3>
                  <p className="text-center text-[16px] leading-[25px] text-[#000000]">Unity — Unreal Engine — Swift — Kotlin — Flutter — Firebase — Play Console & App Store Connect — PlayFab / Unity Gaming Services — AWS / GCP — Kubernetes / Docker — Remote Config, A/B testing, and feature flags — RevenueCat / native billing — Adjust / AppsFlyer / SKAN</p>
               </div>
               <img src={line} alt="line" className="w-full" style={{ objectFit: 'contain' }} />
            </div>
         </Container>
      </section>
   );
}